/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices update after every race, based on the last three races' PPM. Budget Boost's probabilities refresh at each stage of the weekend — FP1, FP2, FP3, qualifying, and the race — so the forecast gets sharper as more session data comes in, right up until the official change lands after the chequered flag.`)
};

const es_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los precios se actualizan después de cada carrera, según el PPM de las últimas tres carreras. Las probabilidades de Budget Boost se actualizan en cada etapa del fin de semana — FP1, FP2, FP3, clasificación y carrera — así que el pronóstico se afina a medida que llegan más datos de cada sesión, hasta que llega el cambio oficial tras la bandera a cuadros.`)
};

const de_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise werden nach jedem Rennen aktualisiert, basierend auf dem PPM der letzten drei Rennen. Die Wahrscheinlichkeiten von Budget Boost aktualisieren sich in jeder Phase des Wochenendes — FP1, FP2, FP3, Qualifying und Rennen —, sodass die Prognose mit jeder weiteren Session schärfer wird, bis die offizielle Änderung nach der Zielflagge eintrifft.`)
};

const nl_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen worden na elke race bijgewerkt, op basis van de PPM van de laatste drie races. De kansen van Budget Boost worden ververst bij elke fase van het weekend — FP1, FP2, FP3, kwalificatie en de race — zodat de voorspelling scherper wordt naarmate er meer sessiedata binnenkomt, tot aan de officiële wijziging na de finishvlag.`)
};

const fr_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les prix se mettent à jour après chaque course, sur la base du PPM des trois dernières courses. Les probabilités de Boost Budget se rafraîchissent à chaque étape du week-end — FP1, FP2, FP3, qualifications et course — si bien que la prévision s'affine à mesure que les données de chaque session arrivent, jusqu'au changement officiel qui tombe après le drapeau à damier.`)
};

const it_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I prezzi si aggiornano dopo ogni gara, in base al PPM delle ultime tre gare. Le probabilità di Budget Boost si aggiornano a ogni fase del weekend — FP1, FP2, FP3, qualifica e gara — così la previsione si affina man mano che arrivano i dati delle sessioni, fino alla variazione ufficiale che arriva dopo la bandiera a scacchi.`)
};

const pt_br2_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os preços são atualizados depois de cada corrida, com base no PPM das últimas três corridas. As probabilidades do Impulso de Orçamento são atualizadas em cada etapa do fim de semana — FP1, FP2, FP3, classificação e corrida — então a previsão fica mais precisa conforme mais dados de sessão chegam, até a mudança oficial acontecer depois da bandeira quadriculada.`)
};

const pt_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os preços são atualizados após cada corrida, com base no PPM das últimas três corridas. As probabilidades do Budget Boost são atualizadas em cada fase do fim de semana — FP1, FP2, FP3, qualificação e corrida — para que a previsão fique mais precisa à medida que chegam mais dados de sessões, até a alteração oficial ser aplicada depois da bandeira axadrezada.`)
};

const ja_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格は毎レース後、直近3レースのPPMに基づいて更新されます。バジェットブーストの確率は、FP1、FP2、FP3、予選、レースという週末の各段階で更新されるため、セッションのデータが増えるほど予測の精度が上がり、チェッカーフラッグ後に公式の変更が反映されるまで更新され続けます。`)
};

const zh_f1_bb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格会在每场比赛后更新，依据的是最近三场比赛的 PPM。Budget Boost 的概率会在比赛周末的每个阶段刷新——FP1、FP2、FP3、排位赛和正赛——因此随着更多赛段数据的加入，预测会越来越精准，直到格子旗挥动后官方调价正式落地。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq2_a", locale)
	if (locale === "en") return en_f1_bb_faq2_a(inputs)
	if (locale === "es") return es_f1_bb_faq2_a(inputs)
	if (locale === "de") return de_f1_bb_faq2_a(inputs)
	if (locale === "nl") return nl_f1_bb_faq2_a(inputs)
	if (locale === "fr") return fr_f1_bb_faq2_a(inputs)
	if (locale === "it") return it_f1_bb_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq2_a(inputs)
	if (locale === "pt") return pt_f1_bb_faq2_a(inputs)
	if (locale === "ja") return ja_f1_bb_faq2_a(inputs)
	return zh_f1_bb_faq2_a(inputs)
};